import * as actions from '@redux-actions/';

import URLS from '@utils/urlList';

import { getMockedFile } from '@utils/utils';

import axios, { AxiosRequestConfig } from 'axios';

export const getDashboardInformations = (isMockRequest: boolean, storeId: string) => {
    if (isMockRequest) {
        const getDashboardInformations =
            '/data/mocks/dashboard_get_dashboard_informations_mock.json';
        return dispatch => {
            dispatch(actions.getDashboardInformationsPending());
            getMockedFile(getDashboardInformations)
                .then(response => {
                    dispatch(actions.getDashboardInformationsSuccess(response?.data));
                })
                .catch(() => dispatch(actions.getDashboardInformationsError()));
        };
    } else {
        const getDashboardInformationsUrl = URLS.GET_DASHBOARD_INFORMATIONS.replace(
            '{storeId}',
            storeId
        ).replace('{noCache}', new Date().getTime().toString() );

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getDashboardInformationsUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            dispatch(actions.getDashboardInformationsPending());
            axios(config)
                .then(response => {
                    dispatch(actions.getDashboardInformationsSuccess(response?.data));
                })
                .catch(() => dispatch(actions.getDashboardInformationsError()));
        };
    }
};

export const getMyAccountDashboardEspot = (isMockRequest: boolean, storeId: string) => {
    if (isMockRequest) {
        const getMyAccountDashboardEspot =
            '/data/mocks/dashboard_get_my_account_dashboard_espot_mock.json';
        return dispatch => {
            dispatch(actions.getMyAccountDashboardEspotPending());
            getMockedFile(getMyAccountDashboardEspot)
                .then(response => {
                    dispatch(
                        actions.getMyAccountDashboardEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0].marketingContentDescription?.[0].marketingText?.replace(
                                /\\/g,
                                ''
                            )
                        )
                    );
                })
                .catch(() => dispatch(actions.getMyAccountDashboardEspotError()));
        };
    } else {
        const getMyAccountDashboardEspotSuccessUrl = URLS.GET_MY_ACCOUNT_DASHBOARD_ESPOT.replace(
            '{storeId}',
            storeId
        ).replace('{noCache}', new Date().getTime().toString() );

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getMyAccountDashboardEspotSuccessUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            dispatch(actions.getMyAccountDashboardEspotPending());
            axios(config)
                .then(response => {
                    dispatch(
                        actions.getMyAccountDashboardEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0]
                                .marketingContentDescription?.[0].marketingText
                        )
                    );
                })
                .catch(() => dispatch(actions.getMyAccountDashboardEspotError()));
        };
    }
};

export const getMyAccountReorderTopDashboardEspot = (isMockRequest: boolean, storeId: string) => {
    if (isMockRequest) {
        const getMyAccountDashboardEspot =
            '/data/mocks/dashboard_get_my_account_top_dashboard_espot_mock.json';
        return dispatch => {
            dispatch(actions.getMyAccountTopDashboardEspotPending());
            getMockedFile(getMyAccountDashboardEspot)
                .then(response => {
                    dispatch(
                        actions.getMyAccountTopDashboardEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0].marketingContentDescription?.[0].marketingText?.replace(
                                /\\/g,
                                ''
                            )
                        )
                    );
                })
                .catch(() => dispatch(actions.getMyAccountTopDashboardEspotError()));
        };
    } else {
        const getMyAccountDashboardEspotSuccessUrl = URLS.GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT.replace(
            '{storeId}',
            storeId
        ).replace('{noCache}', new Date().getTime().toString() );

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getMyAccountDashboardEspotSuccessUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            dispatch(actions.getMyAccountReorderTopDashboardEspotPending());
            axios(config)
                .then(response => {
                    dispatch(
                        actions.getMyAccountReorderTopDashboardEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0]
                                .marketingContentDescription?.[0].marketingText
                        )
                    );
                })
                .catch(() => dispatch(actions.getMyAccountReorderTopDashboardEspotError()));
        };
    }
};

export const getMyAccountTopDashboardEspot = (isMockRequest: boolean, storeId: string) => {
    if (isMockRequest) {
        const getMyAccountDashboardEspot =
            '/data/mocks/dashboard_get_my_account_top_dashboard_espot_mock.json';
        return dispatch => {
            dispatch(actions.getMyAccountTopDashboardEspotPending());
            getMockedFile(getMyAccountDashboardEspot)
                .then(response => {
                    dispatch(
                        actions.getMyAccountTopDashboardEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0].marketingContentDescription?.[0].marketingText?.replace(
                                /\\/g,
                                ''
                            )
                        )
                    );
                })
                .catch(() => dispatch(actions.getMyAccountTopDashboardEspotError()));
        };
    } else {
        const getMyAccountDashboardEspotSuccessUrl = URLS.GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT.replace(
            '{storeId}',
            storeId
        ).replace('{noCache}', new Date().getTime().toString() );

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getMyAccountDashboardEspotSuccessUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            dispatch(actions.getMyAccountTopDashboardEspotPending());
            axios(config)
                .then(response => {
                    dispatch(
                        actions.getMyAccountTopDashboardEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0]
                                .marketingContentDescription?.[0].marketingText
                        )
                    );
                })
                .catch(() => dispatch(actions.getMyAccountTopDashboardEspotError()));
        };
    }
};

export const getMyAccountBottomDashboardEspot = (isMockRequest: boolean, storeId: string) => {
    if (isMockRequest) {
        const getMyAccountDashboardEspot =
            '/data/mocks/dashboard_get_my_account_bottom_dashboard_espot_mock.json';
        return dispatch => {
            dispatch(actions.getMyAccountBottomDashboardEspotPending());
            getMockedFile(getMyAccountDashboardEspot)
                .then(response => {
                    dispatch(
                        actions.getMyAccountBottomDashboardEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0].marketingContentDescription?.[0].marketingText?.replace(
                                /\\/g,
                                ''
                            )
                        )
                    );
                })
                .catch(() => dispatch(actions.getMyAccountBottomDashboardEspotError()));
        };
    } else {
        const getMyAccountDashboardEspotSuccessUrl = URLS.GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT.replace(
            '{storeId}',
            storeId
        ).replace('{noCache}', new Date().getTime().toString() );

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getMyAccountDashboardEspotSuccessUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            dispatch(actions.getMyAccountBottomDashboardEspotPending());
            axios(config)
                .then(response => {
                    dispatch(
                        actions.getMyAccountBottomDashboardEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0]
                                .marketingContentDescription?.[0].marketingText
                        )
                    );
                })
                .catch(() => dispatch(actions.getMyAccountBottomDashboardEspotError()));
        };
    }
};